import api from '@/shared/utils/apiConfig';

export interface TreatmentCatalogActorRef {
  id: string;
  name: string;
}

export interface TreatmentCategory {
  id: string;
  name: string;
  categoryCode: string;
  isSystem: boolean;
  isActive: boolean;
  createdBy?: TreatmentCatalogActorRef;
  updatedBy?: TreatmentCatalogActorRef;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTreatmentCategoryPayload {
  name: string;
}

export interface UpdateTreatmentCategoryPayload {
  name?: string;
  isActive?: boolean;
}

interface ApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  count?: number;
  message?: string;
}

export const treatmentCategoryAPI = {
  getAll: async (includeInactive = false): Promise<ApiResponse<TreatmentCategory[]>> => {
    const response = await api.get('/treatment-categories', {
      params: includeInactive ? { includeInactive: 'true' } : undefined,
    });
    return response.data;
  },

  create: async (
    payload: CreateTreatmentCategoryPayload
  ): Promise<ApiResponse<TreatmentCategory>> => {
    const response = await api.post('/treatment-categories', payload);
    return response.data;
  },

  update: async (
    id: string,
    payload: UpdateTreatmentCategoryPayload
  ): Promise<ApiResponse<TreatmentCategory>> => {
    const response = await api.put(`/treatment-categories/${id}`, payload);
    return response.data;
  },

  deactivate: async (id: string): Promise<ApiResponse<TreatmentCategory>> => {
    const response = await api.delete(`/treatment-categories/${id}`);
    return response.data;
  },
};
